import { Map as map } from 'immutable';
const C = require("../constants");

function CategorySelectReducer(state = map(), action) {
    switch (action.type) {
        case C.CATEGORY_SELECT:
            return action.data;
        default:
            return state;
    }
};

export default CategorySelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/CategorySelectReducer.js